<template>
    <BreadCrumb PageTitle="Paiement KKiaPay d'un BESC" />
    <PaiementKKiaPay />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import PaiementKKiaPay from "@/components/BESC/PaiementKKiaPay.vue";
  
    export default defineComponent({
      name: "PaiementKKiaPayPage",
      components: {
        BreadCrumb,
        PaiementKKiaPay,
      },
    });
  </script>